<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_v"></a>THE</h1>
<h1 class="h1a">Tribal<br/>Knot</h1>
<p class="subtitle"><em>A Memoir of Family,<br/>Community,<br/>and a Century of Change</em></p>
<p class="imagec"><img alt="image" src="images/f000v-01.jpg"/></p>
<p class="author">REBECCA<br/>MCCLANAHAN</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b5580d4a